"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import useCapacitor from "@/hooks/useCapacitor";
import { ManifoldClaimStatus, ManifoldPhase, useMemesManifoldClaim } from "@/hooks/useManifoldClaim";
import { useMemo, useState } from "react";
export interface CountdownData {
  readonly title: string;
  readonly targetDate: number;
  readonly showAllowlistInfo: boolean;
  readonly showMintBtn: boolean;
  readonly isActive: boolean;
}
export type MintCountdownState = {
  type: "loading";
} | {
  type: "error";
} | {
  type: "sold_out";
} | {
  type: "finalized";
} | {
  type: "countdown";
  countdown: CountdownData;
};
interface UseMintCountdownStateOptions {
  hideMintBtn?: boolean;
}
export function useMintCountdownState(nftId, opts) {
  const $ = _c(11);
  const [errorFromCallback, setErrorFromCallback] = useState(false);
  const [prevNftId, setPrevNftId] = useState(nftId);
  if (nftId !== prevNftId) {
    setPrevNftId(nftId);
    setErrorFromCallback(false);
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setErrorFromCallback(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const manifoldClaim = useMemesManifoldClaim(nftId, t0);
  const isError = errorFromCallback && (!manifoldClaim || manifoldClaim.isError);
  const {
    isIos
  } = useCapacitor();
  const {
    country
  } = useCookieConsent();
  const showMintBtn = !opts?.hideMintBtn && !(isIos && country !== "US");
  let t1;
  bb0: {
    if (isError) {
      let t2;
      if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          type: "error"
        };
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    if (!manifoldClaim) {
      let t2;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          type: "loading"
        };
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t1 = t2;
      break bb0;
    }
    if (manifoldClaim.isSoldOut) {
      let t2;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          type: "sold_out"
        };
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb0;
    }
    if (manifoldClaim.isFinalized) {
      let t2;
      if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
          type: "finalized"
        };
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      t1 = t2;
      break bb0;
    }
    const phaseName = manifoldClaim.phase === ManifoldPhase.ALLOWLIST && manifoldClaim.memePhase ? manifoldClaim.memePhase.name : manifoldClaim.phase;
    const isUpcoming = manifoldClaim.status === ManifoldClaimStatus.UPCOMING;
    const t2 = `${phaseName} ${isUpcoming ? "Starts In" : "Ends In"}`;
    const t3 = isUpcoming ? manifoldClaim.startDate : manifoldClaim.endDate;
    const t4 = manifoldClaim.phase === ManifoldPhase.ALLOWLIST;
    const t5 = !isUpcoming;
    let t6;
    if ($[5] !== showMintBtn || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
      t6 = {
        type: "countdown",
        countdown: {
          title: t2,
          targetDate: t3,
          showAllowlistInfo: t4,
          showMintBtn,
          isActive: t5
        }
      };
      $[5] = showMintBtn;
      $[6] = t2;
      $[7] = t3;
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t1 = t6;
  }
  return t1;
}